import client from '../client'

export async function addMembership(membershipDetails) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/Members/AddUserMembership`, {
    headers: { 'Content-Type': 'application/json ' },
    method: 'POST',
    body: JSON.stringify(membershipDetails),
  })
}
